import React from 'react'
import { useMutation } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ManagementAddNewLoanValidateFuckingAdd } from 'services/loans/manager'

export default function useSetRealAdd() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IManagementAddPayload) => {
            return ManagementAddNewLoanValidateFuckingAdd(payload)
        },
        onSuccess: (response, variables) => {
            toast.success('وام با موفقیت ثبت گردید')
            navigate(`/fund/${state?.payload?.moneyPool}`, {
                state: { poolShipId: state?.payload?.poolShip },
            })
        },
        onError: (error) => {
            toast.error('مشکلی رخ داده!')
        },
    })

    return { isLoading, mutate }
}
